import React from 'react';

// components
import { Grid, Paper } from '@material-ui/core';
import FieldSkeleton from 'components/Skeleton/FieldSkeleton';
import { TableSkeleton } from 'components/Skeleton';

// styles
import { MuiThemeProvider } from '@material-ui/core/styles';
import { getMuiTheme } from 'styles/themes';

export const EndpointSkeleton = (): JSX.Element => {
  return (
    <Grid container spacing={ 1 }>
      <Grid item xs={ 12 } sm={ 12 }>
        <Paper>
          <FieldSkeleton/>
        </Paper>
      </Grid>
      <Grid item xs={ 12 } sm={ 12 } container spacing={ 1 }>
        <Grid item xs={ 12 } md={ 4 }>
          <Paper>
            <MuiThemeProvider theme={ getMuiTheme({ embeddedTable: true }) }>
              <TableSkeleton
                rows={ 5 }
                cols={ 1 }
                options={ {
                  elevation: 0,
                  pagination: false,
                } }
              />
            </MuiThemeProvider>
          </Paper>
        </Grid>
        <Grid item xs={ 12 } md={ 8 }>
          <Paper>
            <MuiThemeProvider theme={ getMuiTheme({ embeddedTable: true }) }>
              <TableSkeleton
                rows={ 5 }
                cols={ 1 }
                options={ {
                  elevation: 0,
                  pagination: false,
                } }
              />
            </MuiThemeProvider>
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={ 12 } sm={ 12 }>
        <Paper>
          <FieldSkeleton height={ 250 }/>
        </Paper>
      </Grid>
    </Grid>
  );
};